import {EventEmitter} from 'events'
import {Alert, Events} from './definitions'

export function newAlert(
  msg,
  type = Alert.ERROR,
  autoClose = true,
  dismissible = true
) {
  EventHub.emit(Events.SHOW_ALERT, msg, type, autoClose, dismissible)
}

const EventHub = new EventEmitter()

export default EventHub
